import React, {Component} from "react";
import {
    Button,
    Col,
    Form,
    FormGroup,
    FormText,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import Select from "../../../local_node_modules/react-select"
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import Datetime from "react-datetime";
import moment from "moment/moment";

class OptikInformationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optikInfoData: null,
            selectedBranch: null,
            selectedBranchData: null,
            error: {}
        }
        this.changeBranch = this.changeBranch.bind(this);
        this.changeBranchInfo = this.changeBranchInfo.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
    }

    componentWillMount() {
        this.setState({optikInfoData: this.props.optikInfoData});
    }

    changeBranch(e){
        this.setState({selectedBranch: e});
        if (this.state.optikInfoData !== null){
            this.state.optikInfoData.map(branch => {
                if (branch.recordId === e)
                    this.setState({selectedBranchData: branch});
            });
        }else {
            this.props.optikInfoData.map(branch => {
                if (branch.recordId === e)
                    this.setState({selectedBranchData: branch});
            });
        }

    }

    changeBranchInfo(e){
        let name = e.target.name
        let value = e.target.value
        let checked = e.target.checked;
        let optikInfoData = deepCopyObject(this.state.optikInfoData);
        let selectedBranchData = deepCopyObject(this.state.selectedBranchData);

        if(name === "hasMesulMudur") {
            selectedBranchData["hasMesulMudur"] = !checked;
        }else{
            selectedBranchData[name] = value;
        }

        if(name === "hasMesulMudur" && !selectedBranchData.hasMesulMudur){
            selectedBranchData["mesulMudurAdSoyad"] = null;
            selectedBranchData["mesulMudurBelgeNo"] = null;
            selectedBranchData["mesulMudurRuhsatnameTarih"] = null;
        }
        optikInfoData.map(branch => {
            if (branch.recordId === this.state.selectedBranch){
                if(name === "hasMesulMudur"){
                    branch["mesulMudurAdSoyad"] = null;
                    branch["mesulMudurBelgeNo"] = null;
                    branch["mesulMudurRuhsatnameTarih"] = null;
                    branch["hasMesulMudur"] = !checked;
                }else{
                    branch[name] = value;
                }

            }
        })

        this.setState({optikInfoData,selectedBranchData});
    }

    onChangeDate(momentObj, type, fieldName) {
        let optikInfoData = deepCopyObject(this.state.optikInfoData);
        let selectedBranchData = deepCopyObject(this.state.selectedBranchData);
        let {error} = this.state;

        if(selectedBranchData) {
            let value;
            if (!(typeof momentObj === "string")) {
                value = momentObj.format("YYYY-MM-DD");
                error[fieldName] = undefined

            } else {
                value = moment(momentObj, "YYYY-MM-DD");
                error[fieldName] = {
                    className: "is-invalid",
                    message: "Tarih formatı hatalı. GG-AA-YYYY biçimine uyunuz."
                }

            }

            optikInfoData.map(branch => {
                if (branch.recordId === this.state.selectedBranch) {
                    branch[fieldName] = value;
                }
            })
            selectedBranchData[fieldName] = value;

            this.setState({optikInfoData, error, selectedBranchData})
        }
    }

    saveClicked(){
        let data = deepCopyObject(this.state.optikInfoData);
        let params = {
            url: `/customer/saveOptikBranches`,
            method: "post",
            data: data,
        }
        request(params)
            .then(response => {
                this.setState(()=>this.props.toggle(false));
                Alert.success("İşlem başarıyla tamamlandı.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }
    render() {
        return (
            <Modal  isOpen={this.props.isOpen} size="lg">
                <ModalHeader
                    className="justify-content-center">
                    Şube Bilgileri
                </ModalHeader>
                <ModalBody>
                    <div>
                        <Form>
                            <FormGroup row style={{textAlign: 'center'}}>
                                <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: '16px'}}>Eksik şube
                                    bilgilerinizi
                                    doldurmak için aşağıdan şube seçiniz.</Label>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4}>Şube : </Label>
                                <Col sm={8}>
                                    <Select id="branch"
                                            name="branch"
                                            value={this.state.selectedBranch}
                                            clearable={false}
                                            placeholder="Seçiniz..."
                                            noResultsText="Kayıt bulunamadı."
                                            onChange={(e)=>this.changeBranch(e.value)}
                                            options={this.props.optikInfoData.map(branch =>({
                                                value: branch.recordId,
                                                label: branch.branchName
                                            }))}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">Mükellef Adı: *</Label>
                                <Col sm={8}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={!this.state.selectedBranch}
                                           name="sgkMukellefAdi"
                                           value={this.state.selectedBranchData ? (this.state.selectedBranchData.sgkMukellefAdi === null ? "" : this.state.selectedBranchData.sgkMukellefAdi) : ""}
                                           onChange={(e) => this.changeBranchInfo(e)}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">Mükellef Kodu: *</Label>
                                <Col sm={8}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={!this.state.selectedBranch}
                                           name="sgkMukellefKodu"
                                           value={this.state.selectedBranchData ? (this.state.selectedBranchData.sgkMukellefKodu === null ? "" : this.state.selectedBranchData.sgkMukellefKodu) : ""}
                                           onChange={(e) => this.changeBranchInfo(e)}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">Mesul Müdür Adı Soyadı: *</Label>
                                <Col sm={8}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={!this.state.selectedBranchData ? !this.state.selectedBranchData :(!this.state.selectedBranchData.hasMesulMudur ? !this.state.selectedBranchData.hasMesulMudur : false)}
                                           name="mesulMudurAdSoyad"
                                           value={this.state.selectedBranchData ? (this.state.selectedBranchData.mesulMudurAdSoyad === null ? "" : this.state.selectedBranchData.mesulMudurAdSoyad) : ""}
                                           onChange={(e) => this.changeBranchInfo(e)}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">Mesul Müdür Belge No: *</Label>
                                <Col sm={8}>
                                    <input className="form-control"
                                           type="text"
                                           disabled={!this.state.selectedBranchData ? !this.state.selectedBranchData :(!this.state.selectedBranchData.hasMesulMudur ? !this.state.selectedBranchData.hasMesulMudur : false)}                                           name="mesulMudurBelgeNo"
                                           value={this.state.selectedBranchData ? (this.state.selectedBranchData.mesulMudurBelgeNo === null ? "" : this.state.selectedBranchData.mesulMudurBelgeNo) : ""}
                                           onChange={(e) => this.changeBranchInfo(e)}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="iban">Mesul Müdür Ruhsatname Tarihi: *</Label>
                                <Col sm={8}>
                                    <Datetime locale="tr"
                                              id="mesulMudurRuhsatnameTarih"
                                              className="datepicker"
                                              input={true}
                                              inputProps={{disabled:!this.state.selectedBranchData ? !this.state.selectedBranchData :(!this.state.selectedBranchData.hasMesulMudur ? !this.state.selectedBranchData.hasMesulMudur : false)}}
                                              closeOnSelect={true}
                                              value={this.state.selectedBranchData ? (moment(this.state.selectedBranchData.mesulMudurRuhsatnameTarih, "YYYY-MM-DD", true).isValid() ? moment(this.state.selectedBranchData.mesulMudurRuhsatnameTarih).format("DD-MM-YYYY") : this.state.selectedBranchData.mesulMudurRuhsatnameTarih) : ""}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              onChange={(e) => this.onChangeDate(e, "date", "mesulMudurRuhsatnameTarih")}/>
                                    {this.state.error && this.state.error.mesulMudurRuhsatnameTarih &&
                                    <FormText className="text-danger">
                                        {this.state.error.mesulMudurRuhsatnameTarih.message}
                                    </FormText>
                                    }
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for="hasMesulMudur">Optiysen Mesul Müdür Bilgilerini girmek istemiyorum</Label>
                                <Col sm={1}>
                                    <input type="checkbox"
                                           name={"hasMesulMudur"}
                                           value={this.state.selectedBranchData ? !this.state.selectedBranchData.hasMesulMudur: false}
                                           disabled={!this.state.selectedBranch}
                                           checked={this.state.selectedBranchData ? !this.state.selectedBranchData.hasMesulMudur : false}
                                           style={{float: "left"}}
                                           onChange={(e) => e && this.changeBranchInfo(e)}/>
                                </Col>
                            </FormGroup>
                        </Form>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary" onClick={()=>this.props.toggle(false)}>
                        Kapat
                    </Button>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="success" onClick={this.saveClicked}>
                        Kaydet
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }

}
export default OptikInformationModal;